export const tvc = {
    agencyCode: '403',
    name: 'Texas Veterans Commission',
    shortName: 'TVC',
    slug: 'tvc',
  };
  